import get from 'lodash-es/get'
import isNaN from 'lodash-es/isNaN'
import isNil from 'lodash-es/isNil'
import React, { useMemo } from 'react'
import DetailsData from './DetailsData'
import type {
  ItemProps,
  MLSDetailsSubViewProps,
  SectionProps,
  SubItemProps
} from './types'

export const Section: React.FC<SectionProps> = ({
  id,
  children,
  title,
  onClick
}) => (
  <div className='relative rounded bg-white shadow' id={id} onClick={onClick}>
    <div className='truncate p-3 font-semibold'>{title}</div>
    <div>{children}</div>
  </div>
)

export const Item: React.FC<ItemProps> = ({ title, children }) => {
  if (isNil(children) || isNaN(children)) return null

  const hasChild = (
    (Array.isArray(children) ? children : [children]) as []
  ).reduce((acc, cur) => get(cur, 'props.children') || acc, false)
  if (!hasChild) return null

  return (
    <div className='p-3 pl-5 text-sm odd:bg-gray-50'>
      <div className='pb-2.5 text-gray-600'>{title}</div>
      <div className='mt-1 text-xs'>{children}</div>
    </div>
  )
}

export const SubItem: React.FC<SubItemProps> = ({
  title,
  prefix,
  children
}) => {
  if (isNil(children) || isNaN(children)) return null

  return (
    <div className='mb-2 flex'>
      <span className='inline-block w-32 shrink-0 grow-0 text-gray-400'>
        {title}
        :
      </span>
      {' '}
      {prefix}
      <div>
        {Array.isArray(children) ?
          children.toString().replace('&amp;', '&').split(',').join(', ') :
          children}
      </div>
    </div>
  )
}

const MLSDetailsSubView: React.FC<MLSDetailsSubViewProps> = ({ history }) => {
  const rets = useMemo(() => history?.find(e => e.TransactionType === 'Listing') as TopHap.ListingTransaction | undefined, [history])
  if (!rets) return null

  return (
    <div className='space-y-3'>
      <DetailsData
        Item={Item}
        Section={Section}
        SubItem={SubItem}
        rets={rets}
      />
    </div>
  )
}

export default MLSDetailsSubView
